var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { WarningAmber } from '@mui/icons-material';
import { Box, Grid, Typography } from '@mui/material';
var ErrorBoundary = function (_a) {
    var message = _a.message;
    return (_jsx(Box, __assign({ sx: { width: '100%', height: '100%', textAlign: 'center' } }, { children: _jsxs(Grid, __assign({ container: true, sx: {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                flexDirection: 'column',
                minHeight: '400px',
                textAlign: 'center',
            } }, { children: [_jsx(Grid, __assign({ marginBottom: '16px' }, { children: _jsx(Box, __assign({ sx: { background: '#F1F1F1', borderRadius: '50%', width: 'auto', height: 'auto', padding: '15px' } }, { children: _jsx(WarningAmber, { sx: { fontSize: '50px' } }) })) })), _jsx(Grid, { children: _jsx(Typography, __assign({ variant: "h6" }, { children: message || 'Ops, houve algum problema ao tentar acessar os recursos dessa página.' })) }), _jsx(Grid, { children: _jsx(Typography, __assign({ variant: "body2" }, { children: "Tente novamente mais tarde, se o problema persistir entre em contato com o suporte." })) })] })) })));
};
export default ErrorBoundary;
